import { GridFilterOperator } from '@mui/x-data-grid-pro';

export const pixelsStatusOperators: GridFilterOperator[] = [
  {
    value: 'statusInFilter',
    getApplyFilterFn: filterItem => {
      if (!filterItem.field || !filterItem.value?.length || !filterItem.operator) {
        return null;
      }

      return ({ value }) => {
        return filterItem.value.includes(value);
      };
    },
  },
];
